import { Link, useNavigate } from "react-router-dom";
import { LogOut } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";

export const Logo = () => (
  <Link to="/" className="flex items-center gap-2" data-testid="nav-logo-link">
    <img src="/logo-mark.svg" alt="" className="h-9 w-9" data-testid="nav-logo-mark" />
    <span className="whitespace-nowrap text-base font-extrabold tracking-tight text-slate-900 sm:text-lg">
      Seutrade<span className="text-blue-700"> Direct</span>
    </span>
  </Link>
);

export const SiteHeader = () => {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const onLogout = async () => {
    nav("/");
    await logout();
  };
  return (
    <header className="no-print sticky top-0 z-50 border-b border-slate-200 bg-white/90 backdrop-blur-md">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between gap-4 px-4 sm:px-6">
        <Logo />
        <div className="hidden items-center gap-2 rounded-full border border-emerald-200 bg-emerald-50 px-3 py-1 font-mono text-[11px] font-semibold uppercase tracking-wider text-emerald-700 md:flex">
          <span className="h-1.5 w-1.5 rounded-full bg-emerald-500" /> 50-state + DC coverage
        </div>
        <nav className="flex items-center gap-2">
          {user ? (
            <>
              <Button asChild variant="ghost" className="hover:bg-slate-100 hover:text-slate-900" data-testid="nav-dashboard-link">
                <Link to={user.role === "admin" ? "/admin" : "/dashboard"}>{user.role === "admin" ? "Admin" : "My account"}</Link>
              </Button>
              <Button variant="ghost" size="icon" onClick={onLogout} data-testid="nav-logout-btn" aria-label="Log out">
                <LogOut className="h-4 w-4" />
              </Button>
            </>
          ) : (
            <Button asChild variant="ghost" className="hover:bg-slate-100 hover:text-slate-900" data-testid="nav-login-link">
              <Link to="/login">Log in</Link>
            </Button>
          )}
          <Button asChild className="hidden bg-blue-700 text-white hover:bg-blue-800 hover:text-white sm:inline-flex" data-testid="nav-landing-quote-btn">
            <Link to="/quote">Get a quote</Link>
          </Button>
        </nav>
      </div>
    </header>
  );
};
